import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './rootReducer';
import { customMiddleware } from './middleware';

/**
 * Redux store with:
 * - Combined root reducer
 * - Custom middleware chain
 * - DevTools enabled in development
 */
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore non-serializable values in specific paths if needed
                ignoredActions: [],
                ignoredPaths: [],
            },
        }).concat(customMiddleware),
    devTools: import.meta.env.DEV,
});

export default store;
